import { render, staticRenderFns } from "./btn-arrow-secondary.vue?vue&type=template&id=c95891fe&scoped=true"
import script from "./btn-arrow-secondary.vue?vue&type=script&lang=js"
export * from "./btn-arrow-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95891fe",
  null
  
)

export default component.exports